export default __webpack_public_path__ + "static/media/unit-price.d8773943.svg";